// React.lazy doesn't work with HMR
import loadable from "@loadable/component";

export const iconSvgMap = {
  arrowDown: loadable(() => import("./icons/ArrowDown")),
  arrowLeft: loadable(() => import("./icons/ArrowLeft")),
  arrowLeftShort: loadable(() => import("./icons/ArrowLeftShort")),
  arrowRight: loadable(() => import("./icons/ArrowRight")),
  arrowRightBold: loadable(() => import("./icons/ArrowRightBold")),
  arrowRightCircle: loadable(() => import("./icons/ArrowRightCircle")),
  arrowRightShort: loadable(() => import("./icons/ArrowRightShort")),
  arrowSwoosh: loadable(() => import("./icons/ArrowSwoosh")),
  arrowThinDown: loadable(() => import("./icons/ArrowThinDown")),
  arrowThinRight: loadable(() => import("./icons/ArrowThinRight")),
  arrowUp: loadable(() => import("./icons/ArrowUp")),
  banknote: loadable(() => import("./icons/Banknote")),
  burstBottomRight: loadable(() => import("./icons/BurstBottomRight")),
  burstTopLeft: loadable(() => import("./icons/BurstTopLeft")),
  calendar: loadable(() => import("./icons/Calendar")),
  calendarAlt: loadable(() => import("./icons/CalendarAlt")),
  catBenefitPlayful: loadable(() => import("./icons/CatBenefitPlayful")),
  catBenefitShinyCoat: loadable(() => import("./icons/CatBenefitShinyCoat")),
  catDisappointed: loadable(() => import("./icons/CatDisappointed")),
  catHighFive: loadable(() => import("./icons/CatHighFive")),
  catProfile: loadable(() => import("./icons/CatProfile")),
  catProfileAdult: loadable(() => import("./icons/CatProfileAdult")),
  catProfileAdultSelected: loadable(() => import("./icons/CatProfileAdultSelected")),
  catProfileKitten: loadable(() => import("./icons/CatProfileKitten")),
  catProfileKittenSelected: loadable(() => import("./icons/CatProfileKittenSelected")),
  catProfileSenior: loadable(() => import("./icons/CatProfileSenior")),
  catProfileSeniorSelected: loadable(() => import("./icons/CatProfileSeniorSelected")),
  catScratchingPost: loadable(() => import("./icons/CatScratchingPost")),
  catWalking: loadable(() => import("./icons/CatWalking")),
  catWeightChubby: loadable(() => import("./icons/CatWeightChubby")),
  catWeightHealthy: loadable(() => import("./icons/CatWeightHealthy")),
  catWeightJustRight: loadable(() => import("./icons/CatWeightJustRight")),
  catWeightObese: loadable(() => import("./icons/CatWeightObese")),
  catWeightSkinny: loadable(() => import("./icons/CatWeightSkinny")),
  chevronDownHeavy: loadable(() => import("./icons/ChevronDownHeavy")),
  chevronLeft: loadable(() => import("./icons/ChevronLeft")),
  chevronLeftHeavy: loadable(() => import("./icons/ChevronLeftHeavy")),
  chevronRight: loadable(() => import("./icons/ChevronRight")),
  chevronRightHeavy: loadable(() => import("./icons/ChevronRightHeavy")),
  chevronUpHeavy: loadable(() => import("./icons/ChevronUpHeavy")),
  chicken: loadable(() => import("./icons/Chicken")),
  circle: loadable(() => import("./icons/Circle")),
  clock: loadable(() => import("./icons/Clock")),
  coins: loadable(() => import("./icons/Coins")),
  contactlessPayment:  loadable(() => import("./icons/ContactlessPayment")),
  cow: loadable(() => import("./icons/Cow")),
  creditCard: loadable(() => import("./icons/CreditCard")),
  cross: loadable(() => import("./icons/Cross")),
  crossHeavy: loadable(() => import("./icons/CrossHeavy")),
  crossInverted: loadable(() => import("./icons/CrossInverted")),
  crossSticker: loadable(() => import("./icons/CrossSticker")),
  currency: loadable(() => import("./icons/Currency")),
  deliveryBox: loadable(() => import("./icons/DeliveryBox")),
  download: loadable(() => import("./icons/Download")),
  duck: loadable(() => import("./icons/Duck")),
  elipsis: loadable(() => import("./icons/Elipsis")),
  equals: loadable(() => import("./icons/Equals")),
  error: loadable(() => import("./icons/Error")),
  facebook: loadable(() => import("./icons/Facebook")),
  fiftyOffSticker: loadable(() => import("./icons/FiftyOffSticker")),
  filledTag: loadable(() => import("./icons/FilledTag")),
  fish: loadable(() => import("./icons/Fish")),
  food: loadable(() => import("./icons/Food")),
  frozen: loadable(() => import("./icons/Frozen")),
  gentlyCookedSticker: loadable(() => import("./icons/GentlyCookedSticker")),
  gift: loadable(() => import("./icons/Gift")),
  halloween: loadable(() => import("./icons/Halloween")),
  heartPlusFreeGiftSticker: loadable(() => import("./icons/HeartPlusFreeGiftSticker")),
  heartPlusNoStringsSticker: loadable(() => import("./icons/HeartPlusNoStringsSticker")),
  happierCatSticker: loadable(() => import("./icons/HappierCatSticker")),
  heartPlusSticker: loadable(() => import("./icons/HeartPlusSticker")),
  humanGradeSticker: loadable(() => import("./icons/HumanGradeSticker")),
  information: loadable(() => import("./icons/Information")),
  informationHeavy: loadable(() => import("./icons/InformationHeavy")),
  instagram: loadable(() => import("./icons/Instagram")),
  lightBulb: loadable(() => import("./icons/LightBulb")),
  linkedin: loadable(() => import("./icons/LinkedIn")),
  litterBox: loadable(() => import("./icons/Litterbox")),
  lock: loadable(() => import("./icons/Lock")),
  magnifyingGlass: loadable(() => import("./icons/MagnifyingGlass")),
  mapPin: loadable(() => import("./icons/MapPin")),
  menu: loadable(() => import("./icons/Menu")),
  message: loadable(() => import("./icons/Message")),
  minus: loadable(() => import("./icons/Minus")),
  minusAlt: loadable(() => import("./icons/MinusAlt")),
  multiCat2Cats: loadable(() => import("./icons/MultiCat2Cats")),
  multiCat2CatsSelected: loadable(() => import("./icons/MultiCat2CatsSelected")),
  multiCat3Cats: loadable(() => import("./icons/MultiCat3Cats")),
  multiCat3CatsSelected: loadable(() => import("./icons/MultiCat3CatsSelected")),
  multiCat4Cats: loadable(() => import("./icons/MultiCat4Cats")),
  multiCat4CatsSelected: loadable(() => import("./icons/MultiCat4CatsSelected")),
  noGrainsSticker: loadable(() => import("./icons/NoGrainsSticker")),
  noGrainsStickerSand: loadable(() => import("./icons/NoGrainsStickerSand")),
  nutritionallyBalancedSticker: loadable(() => import("./icons/NutritionallyBalancedSticker")),
  otherMeat: loadable(() => import("./icons/OtherMeat")),
  otherSteamed: loadable(() => import("./icons/OtherSteamed")),
  padlock: loadable(() => import("./icons/Padlock")),
  padlockUnlocked: loadable(() => import("./icons/PadlockUnlocked")),
  pantry: loadable(() => import("./icons/Pantry")),
  pause: loadable(() => import("./icons/Pause")),
  pauseCircled: loadable(() => import("./icons/PauseCircled")),
  pauseInverted: loadable(() => import("./icons/PauseInverted")),
  paypal: loadable(() => import("./icons/PayPal")),
  phone: loadable(() => import("./icons/Phone")),
  pig: loadable(() => import("./icons/Pig")),
  play: loadable(() => import("./icons/Play")),
  plus: loadable(() => import("./icons/Plus")),
  plusAlt: loadable(() => import("./icons/PlusAlt")),
  plusHeavy: loadable(() => import("./icons/PlusHeavy")),
  premiumMeatSticker: loadable(() => import("./icons/PremiumMeatSticker")),
  premiumMeatStickerSand: loadable(() => import("./icons/PremiumMeatStickerSand")),
  scoop: loadable(() => import("./icons/Scoop")),
  scoopHealth: loadable(() => import("./icons/ScoopHealth")),
  scoopPlanet: loadable(() => import("./icons/ScoopPlanet")),
  sheep: loadable(() => import("./icons/Sheep")),
  snowflakeCircled: loadable(() => import("./icons/SnowFlakeCircled")),
  star: loadable(() => import("./icons/Star")),
  subscription: loadable(() => import("./icons/Subscription")),
  success: loadable(() => import("./icons/Success")),
  tag: loadable(() => import("./icons/Tag")),
  thumbsDown: loadable(() => import("./icons/ThumbsDown")),
  thumbsDownFilled: loadable(() => import("./icons/ThumbsDownFilled")),
  thumbsUp: loadable(() => import("./icons/ThumbsUp")),
  thumbsUpFilled: loadable(() => import("./icons/ThumbsUpFilled")),
  tick: loadable(() => import("./icons/Tick")),
  tickAlt: loadable(() => import("./icons/TickAlt")),
  tickHeavy: loadable(() => import("./icons/TickHeavy")),
  tickInverted: loadable(() => import("./icons/TickInverted")),
  tickShort: loadable(() => import("./icons/TickShort")),
  trash: loadable(() => import("./icons/Trash")),
  tray: loadable(() => import("./icons/Tray")),
  traysCircled: loadable(() => import("./icons/TraysCircled")),
  treats: loadable(() => import("./icons/Treats")),
  treatsCircled: loadable(() => import("./icons/TreatsCircled")),
  truck: loadable(() => import("./icons/Truck")),
  turkey: loadable(() => import("./icons/Turkey")),
  userCircle: loadable(() => import("./icons/UserCircle")),
  userProfile: loadable(() => import("./icons/UserProfile")),
  vetFormulatedSticker: loadable(() => import("./icons/VetFormulatedSticker")),
  vetFormulatedStickerSand: loadable(() => import("./icons/VetFormulatedStickerSand")),
  warning: loadable(() => import("./icons/Warning")),
  warningBold: loadable(() => import("./icons/WarningBold")),
  xmas: loadable(() => import("./icons/Xmas")),
  youtube: loadable(() => import("./icons/Youtube")),
};

export const iconSizeClassMap = {
  "2xsmall": "w-4 h-4",
  "1xsmall": "w-5 h-5",
  xsmall: "w-6 h-6",
  small: "w-8 h-8",
  default: "w-11 h-11", // Minimum clickable for accessibility purposes (44px)
  medium: "w-12 h-12",
  mediumLarge: "w-16 h-16",
  large: "w-24 h-24",
  xlarge: "w-32 h-32",
  "2xlarge": "w-48 h-48",
  fit: "w-full h-full",
  radio: "w-16 h-16 lg:w-24 lg:h-24",
};

export const iconScaledSizeClassMap: typeof iconSizeClassMap = {
  "2xsmall": "w-4 h-4 md:w-5 md:h-5",
  "1xsmall": "w-5 h-5 md:w-6 md:h-6",
  xsmall: "w-6 h-6 md:w-8 md:h-8",
  small: "w-8 h-8 md:w-10 md:h-10",
  default: "w-11 h-11 md:w-12 md:h-12", // Minimum clickable for accessibility purposes (44px)
  medium: "w-12 h-12 md:w-14 md:h-14",
  mediumLarge: "w-16 h-16 md:w-20 md:h-20",
  large: "w-24 h-24 md:w-28 md:h-28",
  xlarge: "w-32 h-32 md:w-36 md:h-36",
  "2xlarge": "w-48 h-48 md:w-52 md:h-52",
  fit: "w-full h-full",
  radio: "w-16 h-16 lg:w-24 lg:h-24",
};

export type Size = keyof typeof iconSizeClassMap;
export type IconSvg = keyof typeof iconSvgMap;